'use strict';

/**
 * Defines the daterangepicker config and does init daterangepicker
 *
 * @todo make the whole shit i18n
 * @see https://github.com/dangrossman/bootstrap-daterangepicker
 */
var waDateRangePicker = {
	dateRangeFilter: function() {
		$('#date-range-filter').daterangepicker({
			locale: {
				format: 'YYYY-MM-DD',
				separator: ' - ',
				applyLabel: 'Apply',
				cancelLabel: 'Cancel',
				fromLabel: 'From',
				toLabel: 'To',
				customRangeLabel: 'Custom',
				daysOfWeek: [
					'Su',
					'Mo',
					'Tu',
					'We',
					'Th',
					'Fr',
					'Sa'
				],
				monthNames: [
					'Enero',
					'Febrero',
					'Marzo',
					'Abril',
					'Mayo',
					'Junio',
					'Julio',
					'Agusto',
					'Septiembre',
					'Octubre',
					'Noviembre',
					'Diciembre'
				],
				firstDay: 1
			},
			'autoUpdateInput': false,
			'showDropdowns': true,
			'showISOWeekNumbers': true,
			'alwaysShowCalendars': true,
			'ranges': {
				'Today': [
					moment(),
					moment().subtract(1, 'days')
				],
				'Yesterday': [
					moment().subtract(1, 'days').startOf('day'),
					moment().subtract(1, 'days').endOf('day')
				],
				'Last 7 Days': [
					moment(),
					moment().subtract(7, 'days')
				],
				'Last 30 Days': [
					moment(),
					moment().subtract(30, 'days')
				],
				'This Month': [
					moment().startOf('month'),
					moment().endOf('month')
				],
				'Last Month': [
					moment().subtract(1, 'months').startOf('month'),
					moment().subtract(1, 'months').endOf('month')
				]
			}
		});
	},
};
